<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-settlementList',
  components: { PageTable },
}
</script>
